<template>
    <div>
        <div v-if="!cropping" class="d-flex justify-content-between">
            <h2 v-if="header != ''">{{ header }}</h2>
            <div class="form-control uhe-search-input-wrapper d-flex mb-2">
                <i class="material-icons mr-1">search</i>

                <input
                    ref="searchInput"
                    class="uhe-search-input flex-fill"
                    type="search"
                    placeholder="Suche"
                    aria-label="Suche"
                    @input="onSearchInput"
                />
            </div>
        </div>
        <div v-if="!imageCollections.length">Keine Sammlungen vorhanden</div>
        <div :class="{ 'd-none': cropping }">
            <div
                v-for="(imageCollection, colInd) in imageCollections"
                :key="imageCollection.id"
            >
                <div class="mb-2" v-if="!imageCollection.hidden || selector">
                    <div class="card-body pt-1 pb-2">
                        <div
                            class="d-flex align-items-center justify-content-between flex-wrap"
                            :class="{ 'uhe-default': size == 'default' }"
                        >
                            <div class="d-flex flex-wrap">
                                <h5 class="card-title mb-0 mr-2">
                                    {{ imageCollection.title }}
                                </h5>
                                <span
                                    v-if="imageCollection.image_tag != null"
                                    :class="[
                                        'badge',
                                        'badge-' +
                                            imageCollection.image_tag.color
                                    ]"
                                    class="mr-2"
                                    >{{ imageCollection.image_tag.title }}</span
                                >
                                <small
                                    v-if="
                                        imageCollection.created_at != undefined
                                    "
                                    class="my-auto text-muted"
                                    >{{
                                        imageCollection.locale_created_at
                                    }}</small
                                >
                            </div>
                            <div
                                class="uhe-d-pointer flex-grow-1 d-flex justify-content-end align-items-center"
                                @click="
                                    showMore = imageCollection.id;
                                    curCollectionImages = [];
                                    getImages();
                                "
                                v-if="
                                    showMore != imageCollection.id && selector
                                "
                            >
                                Mehr zeigen
                            </div>
                            <div
                                class="uhe-d-pointer flex-grow-1 d-flex justify-content-end align-items-center"
                                @click="showMore = -1"
                                v-else-if="selector"
                            >
                                Weniger zeigen
                            </div>
                            <a
                                :href="'/fotos/' + imageCollection.id"
                                class="uhe-link uhe-d-pointer"
                                v-if="!selector"
                                >→ Zur Sammlung</a
                            >
                        </div>
                        <div
                            class="row d-flex justify-content-start flex-nowrap"
                            v-if="
                                showMore != imageCollection.id && showPreviews
                            "
                        >
                            <div
                                class="p-1 flex-shrink-1"
                                v-for="(image,
                                ind) in imageCollection.preview_images"
                                :key="image.id"
                            >
                                <img
                                    :class="[
                                        'uhe-img',
                                        ind >= 5 ? 'uhe-img-fade' : ''
                                    ]"
                                    :src="
                                        baseUrl + 'storage/' + image.thumbPath
                                    "
                                    :alt="image.thumbPath"
                                />
                            </div>
                        </div>
                        <div
                            class="row d-flex justify-content-start flex-wrap"
                            v-else-if="
                                showMore == imageCollection.id &&
                                    curCollectionImages.length
                            "
                        >
                            <div
                                v-for="image in curCollectionImages"
                                :key="image.id"
                                class="uhe-img-container"
                            >
                                <a
                                    class="w-100 h-100 d-flex justify-content-center align-items-center"
                                    @click="
                                        onImageClick(image.id, image.origPath)
                                    "
                                >
                                    <img
                                        class="uhe-img m-1"
                                        :src="
                                            baseUrl +
                                                'storage/' +
                                                image.thumbPath
                                        "
                                        :alt="image.thumbPath"
                                    />
                                </a>
                            </div>
                            <paginator
                                :data="imagePaginatorInfo"
                                @changePage="getImages"
                                class="mb-2"
                            ></paginator>
                        </div>
                        <div v-else-if="showMore == imageCollection.id">
                            Diese Sammlung hat noch keine Bilder.
                        </div>
                    </div>
                </div>
                <hr class="my-2" v-if="colInd < imageCollections.length - 1" />
            </div>
            <paginator
                :data="paginatorInfo"
                @changePage="getImageCollections"
                class="mb-2"
            ></paginator>
        </div>
        <div :class="{ 'd-none': !cropping }">
            <div class="mb-2">
                Bitte wählen Sie den zu verwendenden Bereich aus
            </div>
            <vue-cropper
                ref="cropper"
                :src="imgSrc"
                :view-mode="1"
                :initialAspectRatio="ratio"
                :ready="onCropReady"
                :cropmove="onCropMove"
            ></vue-cropper>
            <div class="d-flex justify-content-end">
                <button
                    class="btn uhe-btn float-right mt-2"
                    @click="confirmCrop()"
                >
                    Auswählen
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
    components: {
        VueCropper
    },
    props: {
        showPreviews: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: "default"
        },
        selector: {
            type: Boolean,
            default: false
        },
        selected: {
            default: undefined
        },
        previewAmount: {
            // disabled
            type: Number,
            default: 6
        },
        imagesPerRow: {
            type: Number,
            default: undefined
        },
        cropper: {
            type: Boolean,
            default: false
        },
        perPage: {
            type: Number,
            default: 15
        },
        header: {
            type: String,
            default: ""
        },
        minAspectRatio: {
            type: Number,
            default: 2
        },
        maxAspectRatio: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            showMore: -1,
            paginatorInfo: undefined,
            imageCollections: [],
            fullscreenImage: { img: 0, images: [] },
            selectedImageId: this.selected,
            selectedImageColId: undefined,
            cropping: false,
            imgSrc: undefined,
            croppedImage: undefined,
            curCollectionImages: [],
            timeout: undefined,
            croppingImage: undefined,
            imagePaginatorInfo: undefined,
            ratio: 2
        };
    },
    mounted() {
        this.getImageCollections();
    },
    methods: {
        getImageCollections(page = -1) {
            if (page < 0) {
                window.axios
                    .get(
                        "/imageCollectionsWithPreviewImages" +
                            "?perPage=" +
                            this.perPage
                    )
                    .then(({ data }) => {
                        this.paginatorInfo = data;
                        this.imageCollections = data.data;
                    });
            } else {
                window.axios
                    .get(
                        "/imageCollectionsWithPreviewImages" +
                            "?perPage=" +
                            this.perPage +
                            "&page=" +
                            page
                    )
                    .then(({ data }) => {
                        this.paginatorInfo = data;
                        this.imageCollections = data.data;
                    });
            }
        },
        getImages(page = -1) {
            let url = "/imageCollections/" + this.showMore;

            if (page > 0) {
                url += "?page=" + page;
            }
            window.axios.get(url).then(data => {
                this.imagePaginatorInfo = data.data;
                this.curCollectionImages = data.data.data;
            });
        },
        setModalData() {
            this.$refs.imgModal.setData(
                this.fullscreenImage.images,
                this.fullscreenImage.img
            );
        },
        emitOpenModal() {
            this.$refs.imgModal.open();
        },
        onImageClick(imgId, origPath) {
            if (!this.cropper) {
                this.selectedImageId = imgId;
                this.$emit("selected", this.selectedImageId);
            } else {
                fetch(this.baseUrl + "storage/" + origPath)
                    .then(res => res.blob()) // Gets the response and returns it as a blob
                    .then(blob => {
                        this.$emit("crop");
                        const file = blob;
                        this.cropping = true;

                        if (!file.type.includes("image/")) {
                            console.log("Please select an image file");
                            return;
                        }
                        if (typeof FileReader === "function") {
                            const reader = new FileReader();
                            reader.onload = event => {
                                this.imgSrc = event.target.result;
                                // rebuild cropperjs with the updated source
                                this.$refs.cropper.replace(event.target.result);
                            };
                            reader.readAsDataURL(file);
                        } else {
                            console.log("Sorry, FileReader API not supported");
                        }
                    });
            }
        },
        upload(file) {
            let image = this.dataURItoBlob(file);

            const formData = new FormData();
            formData.append("file", image, image.name);

            // related to aborting the request
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();

            // the request itself
            axios({
                method: "post",
                url: "/images",
                data: formData,
                cancelToken: source.token
            }).then(response => {
                //this.initPond();
                this.$emit("selected", response.data.id);
            });
        },
        confirmCrop() {
            this.cropImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
            this.upload(this.cropImage);
            this.cropping = false;
        },
        dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(",")[0].indexOf("base64") >= 0)
                byteString = atob(dataURI.split(",")[1]);
            else byteString = unescape(dataURI.split(",")[1]);

            // separate out the mime component
            var mimeString = dataURI
                .split(",")[0]
                .split(":")[1]
                .split(";")[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        },
        onSearchInput(e) {
            if (this.timeout == undefined) {
                this.timeout = setTimeout(this.search, 250);
            } else {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(this.search, 250);
            }
        },
        search(page = -1) {
            if (this.$refs.searchInput.value == "") {
                this.getImageCollections(page);
            } else {
                if (page < 0) {
                    window.axios
                        .get(
                            "/search/imageCollections" +
                                "?perPage=" +
                                this.perPage +
                                "&q=" +
                                this.$refs.searchInput.value
                        )
                        .then(({ data }) => {
                            this.paginatorInfo = data;
                            this.imageCollections = data.data;
                        });
                } else {
                    window.axios
                        .get(
                            "/search/imageCollections" +
                                "?perPage=" +
                                this.perPage +
                                "&page=" +
                                page +
                                "&q=" +
                                this.$refs.searchInput.value
                        )
                        .then(({ data }) => {
                            this.paginatorInfo = data;
                            this.imageCollections = data.data;
                        });
                }
            }
        },
        onCropReady() {
            let cropper = this.$refs.cropper;
            let containerData = cropper.getContainerData();
            let canvasData = cropper.getCanvasData();
            let cropBoxData = cropper.getCropBoxData();
            let aspectRatio = cropBoxData.width / cropBoxData.height;
            let newCropBoxWidth;
            if (aspectRatio < this.minAspectRatio) {
                if (
                    cropBoxData.height * this.minAspectRatio <
                    canvasData.width
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.minAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.minAspectRatio
                    });
                }
            } else if (aspectRatio > this.maxAspectRatio) {
                if (
                    cropBoxData.height * this.maxAspectRatio <
                    canvasData.width
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.maxAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.maxAspectRatio
                    });
                }
            }
        },
        onCropMove(e) {
            let cropper = this.$refs.cropper;
            let cropBoxData = cropper.getCropBoxData();
            let canvasData = cropper.getCanvasData();
            let aspectRatio = cropBoxData.width / cropBoxData.height;
            if (aspectRatio < this.minAspectRatio) {
                if (
                    cropBoxData.height * this.minAspectRatio <
                        canvasData.width &&
                    (e.detail.action == "s" || e.detail.action == "n")
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.minAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.minAspectRatio
                    });
                }
            } else if (aspectRatio > this.maxAspectRatio) {
                if (
                    cropBoxData.height * this.maxAspectRatio <
                        canvasData.width &&
                    (e.detail.action == "s" || e.detail.action == "n")
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.maxAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.maxAspectRatio
                    });
                }
            }
        }
    },
    computed: {
        baseUrl() {
            return window.location.origin + "/";
        },
        colspan() {
            return Math.round(12 / this.imagesPerRow).toString();
        }
    }
};
</script>

<style scoped>
.uhe-img {
    max-height: 150px;
    max-width: 100%;
    height: auto;
}

.uhe-img-fade {
    -webkit-mask-image: -webkit-gradient(
        linear,
        top left,
        top right,
        from(rgba(0, 0, 0, 1)),
        to(rgba(0, 0, 0, 0))
    );
    mask-image: linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
}

.uhe-img:hover {
    opacity: 0.7;
}

.uhe-img-container {
    flex-basis: 33.33%;
    padding: 0 2px 0 2px;
}

@media (min-width: 992px) {
    .uhe-img-container {
        flex-basis: 16.66%;
        padding: 0 5px 0 5px;
    }
}

.uhe-readmore {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
}

.uhe-readmore-icon {
    font-size: 4rem;
}

.uhe-d-pointer {
    cursor: pointer;
}

.uhe-dots {
    font-size: 4rem;
    cursor: auto;
    user-select: none;
}

.card {
    border-radius: 0;
    border-color: rgba(0, 124, 2, 1);
}

.uhe-default {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
</style>


